import { StyleSheet } from 'react-native';
import { Colors } from '@qnpm/q-theme';
import SizeUtil from '../../Utils/SizeUtil';

const { scenes: {baseColor} } = Colors;

// const border = DeviceInfo.isIOS
//     ? {}
//     : {
//         borderWidth: 0.5,
//         borderColor: '#f5f5f5'
//     };

export default StyleSheet.create({
    container: {
        flex: 1,
        flexDirection: 'row',
        justifyContent: 'center',
        alignItems: 'center',
        position: 'absolute',
        top: 0, 
        left: 0,
        bottom: SizeUtil.getRootViewY(),
        right: 0,
        backgroundColor: "transparent"
    }
});
